define([], function () {
  return {
    ContentTab: 580,
    LearnerTab: 581,
    SubstitutionsTab: 582,
    TaskCreate: 583,
    AnyTaskEdit: 584,
    ResponseReview: 585,
    TopicEditName: 600,
    TopicEditStatus: 601,
    TopicDelete: 602,
    TopicDeleteCategoryCodes: 603,
    TopicEditCategoryCodes: 604,
    TopicViewCategoryCodes: 605,
    TopicDeleteExamples: 606,
    TopicEditExamples: 607,
    TopicViewExamples: 608,
    TopicEditLabels: 609,
    TopicViewLabels: 610,
    TopicEditFolder: 611,
    TouchpointDeleteAll: 630,
    TouchpointEditAll: 631,
    TouchpointViewAll: 632,
    TouchpointDeleteSpecific: 633,
    TouchpointEditSpecific: 634,
    TouchpointViewSpecific: 635,
    LocaleDeleteAll: 640,
    LocaleEditAll: 641,
    LocaleViewAll: 642,
    LocaleDeleteSpecific: 643,
    LocaleEditSpecific: 644,
    LocaleViewSpecific: 645,

    getPrivilegeId: function (privilegeName) {
      if (this.hasOwnProperty(privilegeName)) {
        return this[privilegeName];
      }
      const upperValue = privilegeName.toUpperCase();
      for (let prop in this) {
        if (this.hasOwnProperty(prop) && prop.toUpperCase() === upperValue) {
          return this[prop];
        }
      }
      throw new Error("Invalid privilege name: " + privilegeName);
    },

    getPrivilegeName: function (privilegeId) {
      for (let prop in this) {
        if (this.hasOwnProperty(prop) && this[prop] === privilegeId) {
          return prop;
        }
      }
      throw new Error("Invalid privilege ID: " + privilegeId);
    },
  };
});
